import { forwardRef } from 'react'

import { cn } from 'src/shared/utils/cn'

export type ActiveProfileTab = 'overview' | 'listings' | 'reviews' | 'portfolio' | 'activity'

type ProfileTabProps = {
  label: string
  active: boolean
  onClick: () => void
}

const ProfileTab = forwardRef<HTMLDivElement, ProfileTabProps>(({ label, active, onClick }, ref) => {
  return (
    <div
      className={cn(
        'group flex flex-1 cursor-pointer items-center justify-center bg-white py-[18px] transition-all duration-200 ease-in-out xs:max-w-[127px] xs:py-5',
        active && 'border-b-primary',
      )}
      onClick={onClick}
      ref={ref}
      style={
        {
          position: 'relative',
          '--slide-progress': active ? '1' : '0',
        } as React.CSSProperties
      }
    >
      <p
        className={cn(
          'text-sm font-medium leading-[1] text-muted transition-all duration-200 ease-in-out group-hover:font-semibold group-hover:text-primary sm:text-base',
          active && 'font-semibold text-primary',
        )}
      >
        {label}
      </p>
      {/* the underline for the tab regardless if active or not */}
      <div
        className="absolute bottom-[-1.5px] left-0 h-[1.5px] w-full rounded-full bg-lightBorder transition-transform duration-300 ease-out"
        style={{
          transformOrigin: 'left',
        }}
      />
    </div>
  )
})

ProfileTab.displayName = 'ProfileTab'

export default ProfileTab
